import React from "react";

export const HomeIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="home-icon"
    >
      <path
        d="M19.5 21H5.5C4.94772 21 4.5 20.5523 4.5 20V11H1.5L11.8273 1.6115C12.2087 1.26475 12.7913 1.26475 13.1727 1.6115L23.5 11H20.5V20C20.5 20.5523 20.0523 21 19.5 21ZM13.5 19H18.5V9.15745L12.5 3.7029L6.5 9.15745V19H11.5V13H13.5V19Z"
        fill="#848484"
      />
    </svg>
  );
};
